import { render, staticRenderFns } from "./AddToGroup.vue?vue&type=template&id=65ed9f31&scoped=true&"
import script from "./AddToGroup.vue?vue&type=script&lang=js&"
export * from "./AddToGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ed9f31",
  null
  
)

export default component.exports